/**
 * The single source of time in the application.
 *
 * ARCHITECTURAL INVARIANT: no module outside this file may call `Date.now()`,
 * `performance.now()`, or `new Date()`. The scheduler and every scoring path receive time as an
 * argument so that all of it is testable without waiting for real seconds to elapse.
 */
export interface Clock {
  /** Epoch milliseconds. */
  now(): number;
}

export class RealClock implements Clock {
  now(): number {
    return Date.now();
  }
}

/** A clock that only moves when a test moves it. */
export class TestClock implements Clock {
  private t: number;

  constructor(startEpochMs: number) {
    this.t = startEpochMs;
  }

  now(): number {
    return this.t;
  }

  setNow(epochMs: number): void {
    this.t = epochMs;
  }

  advance(ms: number): void {
    this.t += ms;
  }
}

export const MS_PER_DAY = 86_400_000;
